import { Readable } from 'generated/apolloComponents'
import Link from 'next/link'
import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import { ChevronRightIcon } from '@heroicons/react/24/solid'
import ArticlePreview from './ArticlePreview/ArticlePreview'

interface IProps {
  title?: string
  articles?: Readable[]
  type?: string
}

const BlogArticleSection = ({ title, articles, type }: IProps) => {
  const { t } = useTranslation('common')

  if (!articles || articles.length === 0) {
    return null
  }
  return (
    <div className='my-6 md:my-14'>
      {title && (
        <header className='md:flex items-center justify-between'>
          <h2>{t(`common:${title}`)}</h2>
          <p className='mt-2 md:mt-0'>
            <Link
              href={`/readme/s/categories,${type}`}
              prefetch={false}
              title={`${t('blog:see_all')} ${t(`common:${title}`)}`}
              className='align-middle hover:underline'
            >
              {`${t('blog:see_all')} ${t(`common:${title}`)}`}
              <ChevronRightIcon width={12} className='ml-3' />
            </Link>
          </p>
        </header>
      )}
      <div className='flex flex-wrap lg:-mx-6 mt-6 md:mt-10'>
        {articles &&
          articles.map((item, index) => (
            <ArticlePreview
              key={index}
              size='small'
              article={item}
              className='border border-gray-100 rounded-br-xl overflow-hidden'
            />
          ))}
      </div>
    </div>
  )
}

export default BlogArticleSection
